var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.63279,
    cy: 7.09275,
    r: 6.96286,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9485 10.8921L11.8911 9.9494C12.0173 9.82318 12.1778 9.73677 12.3526 9.70086C12.5274 9.66495 12.709 9.68113 12.8747 9.74739L14.0227 10.207C14.192 10.2747 14.337 10.3915 14.4392 10.5424C14.5413 10.6934 14.5959 10.8714 14.5959 11.0537V13.1415C14.5962 13.2656 14.5712 13.3885 14.5224 13.5025C14.4735 13.6166 14.4019 13.7195 14.312 13.805C14.222 13.8904 14.1155 13.9566 13.9991 13.9995C13.8826 14.0424 13.7586 14.061 13.6347 14.0543C5.58727 13.5535 3.96195 6.7375 3.66021 4.12741C3.64559 3.99981 3.65816 3.87056 3.69708 3.74816C3.736 3.62577 3.80039 3.513 3.88602 3.41727C3.97165 3.32154 4.07658 3.24503 4.1939 3.19276C4.31122 3.14049 4.43828 3.11366 4.56671 3.11402H6.6175C6.79976 3.11401 6.97784 3.16861 7.12877 3.27078C7.27969 3.37295 7.39655 3.518 7.46425 3.68721L7.9234 4.83528C7.98966 5.001 8.00584 5.18251 7.96993 5.35734C7.93402 5.53216 7.8476 5.69261 7.72139 5.81879L6.77869 6.76149C6.77869 6.76149 7.30138 10.4363 10.9485 10.8921Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 3.11401V3.98935H12.0075L9.125 6.87181L9.74386 7.49067L12.6263 4.6082V6.61534H13.5017V3.11401H10.0003Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallMissed);
export default __webpack_public_path__ + "static/media/video-call-missed.fa37ffb6efed3cdf2baf298e7d744ab7.svg";
export { ForwardRef as ReactComponent };